import Certona from './Certona.component';

export default Certona;